import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { CheckEmptyPipe } from './pipe/checkEmpty.pipe';
import { CapitalizePipe } from './pipe/capitalize.pipe';
import { CamelCaseToNormal } from './pipe/camelCaseToNormal.pipe';
import { Round } from './pipe/round.pipe';
import { CustomCurrencyPipe } from './pipe/customCurrency.pipe';
import { CurrencySeperatorPipe } from './pipe/currencySeparator.pipe';
import { FormatIBANPipe } from './pipe/formatIBAN.pipe';
import { ConcatPipe } from './pipe/concat.pipe';
import { CurrencyInput } from './pipe/currencyInput.pipe';
import { AppLoaderComponent } from './app-loader/app-loader.component';
import { AppDataLoaderComponent } from './app-data-loader/app-data-loader.component';
import { StripHtmlPipe } from './pipe/striphtml.pipe';
import { LocalizedDatePipe } from './pipe/dataLocalized.pipe';
import { showYearPipe } from './pipe/showYear.pipe';
import { CustomNumberFormatPipe } from './pipe/customNumberFormat.pipe';
import { TruncatePipe } from './pipe/truncate.pipe';
import { FindKeyByValue } from './pipe/findKeyByValue.pipe';
import { FormSubmitValidationDirective } from './directive/submitValidation.directive';
import { SanitizeHtmlPipe } from './pipe/sanitizeHtml.pipe';
import { customCurrencyShortPipe } from './pipe/customCurrencyShort.pipe';
import { EntityBasedChatModule } from '../app-platform-entity-based-chat';
import { PlatformNoDataFoundModule } from '../app-platform-no-data-found';
import { ReadMoreModule } from '../app-platform-read-more';

@NgModule({
    imports: [
        CommonModule,
        TranslateModule.forChild(),
        MatIconModule,
        ReadMoreModule,
        EntityBasedChatModule,
        PlatformNoDataFoundModule
    ],
    declarations: [
        CapitalizePipe,
        CheckEmptyPipe,
        StripHtmlPipe,
        CamelCaseToNormal,
        Round,
        CustomCurrencyPipe,
        FormatIBANPipe,
        LocalizedDatePipe,
        CurrencySeperatorPipe,
        ConcatPipe,
        CurrencyInput,
        AppLoaderComponent,
        AppDataLoaderComponent,
        LocalizedDatePipe,
        showYearPipe,
        CustomNumberFormatPipe,
        FormSubmitValidationDirective,
        TruncatePipe,
        FindKeyByValue,
        SanitizeHtmlPipe,
        customCurrencyShortPipe
    ],
    exports: [
        ReadMoreModule,
        CapitalizePipe,
        StripHtmlPipe,
        CheckEmptyPipe,
        CamelCaseToNormal,
        Round,
        CustomCurrencyPipe,
        FormatIBANPipe,
        EntityBasedChatModule,
        CurrencySeperatorPipe,
        ConcatPipe,
        CurrencyInput,
        PlatformNoDataFoundModule,
        AppLoaderComponent,
        AppDataLoaderComponent,
        LocalizedDatePipe,
        showYearPipe,
        CustomNumberFormatPipe,
        FormSubmitValidationDirective,
        TruncatePipe,
        FindKeyByValue,
        SanitizeHtmlPipe,
        customCurrencyShortPipe
    ],
    providers: []
})
export class PlatformSharedModule {}
